export default __webpack_public_path__ + "static/media/fish_gray.97cf0b1a.svg";